import { User } from '../legacy/types';

type AddressInfo = Pick<User, 'street' | 'zip' | 'city'> & {
  // Street addition is optional as it is not included in the Company profile
  streetAddition?: string | null;
};

export const getAddressString = (
  user: AddressInfo,
  useNewlineSeparator = true,
): string => {
  const { city, street, streetAddition, zip } = user;
  const addressParts = [street];
  if (streetAddition) {
    addressParts.push(streetAddition);
  }
  if (zip && city) {
    addressParts.push(`${zip} ${city}`);
  }
  return addressParts.join(useNewlineSeparator ? '\n' : ', ');
};
